import React from 'react';
import { render } from 'react-dom';
import removeAccents from 'remove-accents';

const decodePropsFromDataset = dataset => ({
  ...dataset,
});

export const renderComponent = (Component, selector) => {
  const el = document.querySelector(selector);
  if (el) {
    const props = decodePropsFromDataset(el.dataset);
    const content = <Component {...props} />;
    return () => render(content, el);
  }
  return () => {};
};

export const urlify = string => removeAccents(string.toLowerCase());

export const localizeUrl = (url, locale) => {
  if (locale === 'sk') {
    return `/sk${url}`;
  }

  return url;
};

export const normalizeUrl = url => {
  if (url.startsWith('http') || url.startsWith('//www.gravatar.com')) {
    return url;
  }

  return `https://www.lbstudio.sk/cms${url}`;
};

export function isoDateToSlovak(isoDate) {
  const [year, month, day] = isoDate.split('T')[0].split('-');
  return `${day}.${month}.${year}`;
}

export default null;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/utils.js